// removes all fields of T except for those in K, provided the keys are in K
export function cherryPick<T, K extends keyof T>(obj: T, keys: K[]): Pick<T, K> {
  const ret = {} as Pick<T, K>;
  keys.forEach((key) => {
    ret[key] = obj[key];
  });
  return ret;
}

export function cherryPickState<T>(keys: (keyof T)[]) {
  return (object: T) => {
    const result = {} as T;
    keys.forEach((key) => {
      result[key] = object[key];
    });
    return result;
  };
}
